export const GET_MALL_GOOD_QRCODE_SUCCESS = 'GET_MALL_GOOD_QRCODE_SUCCESS';
export const SET_CHECK_RESULT = 'SET_CHECK_RESULT';
export const GET_MALL_GOOD_QRCODE_IMGQR = 'GET_MALL_GOOD_QRCODE_IMGQR';
export const SET_CHECK_SCAN_RESULT = 'SET_CHECK_SCAN_RESULT';
export const GET_MAKE_MALL_PAYPAL_URL_SUCCESS = 'GET_MAKE_MALL_PAYPAL_URL_SUCCESS';
export const SET_TAOBAO_ORDER_RESULT = 'SET_TAOBAO_ORDER_RESULT';
export const GET_MALL_COUPON_LIST_SUCCESS = 'GET_MALL_COUPON_LIST_SUCCESS';
export const GET_WEB_ALIPAY_PAGE_SNAPLET_SUCCESS = 'GET_WEB_ALIPAY_PAGE_SNAPLET_SUCCESS';
//export const GET_MALL_ALIPAY_NOTIFICATION_SUCCESS = 'GET_MALL_ALIPAY_NOTIFICATION_SUCCESS';
export const GET_WEB_HAIER_URL_SUCCESS = 'GET_WEB_HAIER_URL_SUCCESS';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
export const LOADING_MESSAGE = '加载中...';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const SET_IS_REQUEST_CHECK_STATUS = 'SET_IS_REQUEST_CHECK_STATUS';
export const SET_IS_REQUEST_COUPON_LIST_STATUS = 'SET_IS_REQUEST_COUPON_LIST_STATUS';
